import React, { useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../../env";

const RaiseRescheduleBooking = () => {
  const [formData, setFormData] = useState({
    bookingRef: "",
    customerName: "",
    hotelName: "",
    oldCheckIn: "",
    newCheckIn: "",
    remarks: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitMessage("");
    try {
      const payload = {
        name: formData.customerName,
        newCheckIn: formData.newCheckIn,
        hotelName: formData.hotelName,
        remark: formData.remarks,
        bookingrefno: formData.bookingRef,
      };
      const response = await axios.post(
        `${REACT_APP_API_URL}api/hotel-booking/reschedule`,
        payload
      );
      setSubmitMessage(response?.data?.message || "Submitted successfully.");
    } catch (error) {
      const message =
        error?.response?.data?.message ||
        "Failed to submit reschedule request.";
      setSubmitMessage(message);
    }
    setSubmitting(false);
  };

  return (
    <div className="container-fluid admin-module-page py-4">
      <div className="admin-page-header mb-4">
        <span className="admin-page-kicker">Hotel Reservations</span>
        <h2 className="admin-page-title fw-bold mb-1">Raise Reschedule Booking</h2>
        <p className="admin-page-description mb-0">Submit a hotel booking reschedule request.</p>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-12">
          <div className="card admin-surface-card">
            <div className="admin-surface-header">
              <h5 className="mb-0">Raise Reschedule Booking</h5>
            </div>
            <div className="admin-surface-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Booking Ref</label>
                    <input
                      type="text"
                      name="bookingRef"
                      className="form-control"
                      value={formData.bookingRef}
                      onChange={handleChange}
                      placeholder="Enter booking reference"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Name</label>
                    <input
                      type="text"
                      name="customerName"
                      className="form-control"
                      value={formData.customerName}
                      onChange={handleChange}
                      placeholder="Enter customer name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Hotel Name</label>
                    <input
                      type="text"
                      name="hotelName"
                      className="form-control"
                      value={formData.hotelName}
                      onChange={handleChange}
                      placeholder="Enter hotel name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">Old Check-in</label>
                    <input
                      type="date"
                      name="oldCheckIn"
                      className="form-control"
                      value={formData.oldCheckIn}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold">New Check-in</label>
                    <input
                      type="date"
                      name="newCheckIn"
                      className="form-control"
                      value={formData.newCheckIn}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-12">
                    <label className="form-label fw-semibold">Remarks</label>
                    <textarea
                      name="remarks"
                      className="form-control"
                      rows="4"
                      value={formData.remarks}
                      onChange={handleChange}
                      placeholder="Enter remarks"
                    />
                  </div>
                  {submitMessage && (
                    <div className="col-12">
                      <div className="alert alert-info mb-0" role="alert">
                        {submitMessage}
                      </div>
                    </div>
                  )}
                  <div className="col-12 d-flex justify-content-end admin-form-actions">
                    <button
                      type="submit"
                      className="btn btn-primary"
                      disabled={submitting}
                    >
                      {submitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RaiseRescheduleBooking;
